
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/flipping-a-house-101",
      function () {
        return require("private-next-pages/articles/flipping-a-house-101.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/flipping-a-house-101"])
      });
    }
  